import CityPage from "../CityPage";

export default function Addison() {
  return <CityPage slug="addison" />;
}
